<template>
  <div class="filter-select-container">
  <el-form-item :label="`${hideLabel ? '' : label}`" style="width: 100%">
    <div class="filter-select">
      <multiselect
        v-if="is_filter && searchable"
        ref="multiselect"
        :value="_value"
        :disabled="disabled"
        @close="blur"
        @open="$emit('focus')"
        @input="input"
        :loading="isLoading"
        :placeholder="placeholder || label"
        :searchable="true"
        selectLabel=""
        :close-on-select="!multiple"
        :preserve-search="false"
        deselectLabel=""
        @search-change="asyncFind"
        :tag-placeholder="isLoading ? 'Загрузка ...' : 'Значение не найдено'"
        selectedLabel="Выбрано"
        :noOptions="isLoading ? 'Загрузка ...' : 'Не найдено'"
        :noResult="isLoading ? 'Загрузка ...' : 'Не найдено'"
        label="label"
        @remove="(e) => $emit('remove', e)"
        @select="(e) => $emit('select', e)"
        track-by="value"
        :multiple="multiple"
        :taggable="multiple && !noTag"
        :options="options"
      >
        <span slot="noOptions">{{ isLoading ? 'Загрузка ...' : 'Не найдено' }}</span>
        <div slot="noResult" slot-scope="{ search }">
          <el-button size="mini" @click="addNew(search)" v-if="addNewEnable">Добавить новое значение</el-button>
          <span v-else>Не найдено</span>
        </div>
        <span
          v-if="searchQuery && !isFind && isSearch"
          slot="afterList" style="display: flex; justify-content: flex-start; padding: 8px 16px; height: 46px; box-sizing: border-box">
                    <el-button size="mini" @click="addNew(searchQuery)" v-if="addNewEnable">Добавить новое значение</el-button>
        </span>
      </multiselect>
      <multiselect
        v-else
        :disabled="disabled"
        ref="multiselect"
        :close-on-select="!multiple"
        :value="_value"
        @open="$emit('focus')"
        @input="input"
        :loading="isLoading"
        :placeholder="placeholder || label"
        :searchable="false"
        @select="(e) => $emit('select', e)"
        @remove="(e) => $emit('remove', e)"
        :taggable="multiple"
        selectLabel=""
        :multiple="multiple"
        deselectLabel=""
        :tag-placeholder="isLoading ? 'Загрузка ...' : 'Значение не найдено'"
        selectedLabel="Выбрано"
        :noOptions="isLoading ? 'Загрузка ...' : 'Не найдено'"
        :noResult="isLoading ? 'Загрузка ...' : 'Не найдено'"
        :label="label_by"
        :track-by="track_by"
        :options="options"
      >
        <span slot="noOptions">{{ isLoading ? 'Загрузка ...' : 'Не найдено' }}</span>
        <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
        <!--        <div slot="noResult" slot-scope="{ search }">-->
        <!--          <el-button size="mini" @click="addNew(search)" v-if="addNewEnable">Добавить новое</el-button>-->
        <!--          <span v-else>Не найдено</span>-->
        <!--        </div>-->
      </multiselect>
      <div v-if="m_v" @click="toggleFilter" class="search-btn">
        <i class="fa fa-search"></i>
      </div>
    </div>
  </el-form-item>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import MobileDetect from 'mobile-detect';

export default {
  name: 'FilterSelect',
  props: {
    options: Array,
    value: [Object, String, Array],
    addNewEnable: Boolean,
    isLoading: Boolean,
    noTag: Boolean,
    label: String,
    onlyValue: Boolean,
    sortByValue: Boolean,
    track_by: {
      type: String,
      default: 'value',
    },
    hideLabel: Boolean,
    label_by: {
      type: String,
      default: 'label',
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: Boolean,
    multiple: Boolean,
    single: Boolean,
    maxLength: Number,
    searchable: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Multiselect,
  },
  data() {
    const md = new MobileDetect(window.navigator.userAgent);
    return {
      isOpen: false,
      searchQuery: '',
      is_mobile: md.mobile() !== null,
      is_filter: md.mobile() === null,
      m_v: md.mobile(),
    };
  },
  computed: {
    isFind() {
      return !!this.options.find(({label}) => this.searchQuery.toLowerCase() === label.toLowerCase())
    },
    isSearch() {
      return !!this.options.find(({label}) => label.toLowerCase().includes(this.searchQuery.toLowerCase()))

    },
    _value: {
      get() {
        if(!this.onlyValue) {
          return this.value
        } else {
          return this.options.find(({value}) => value === this.value)
        }
      },
    },
  },
  methods: {
    asyncFind(query) {
      this.searchQuery = query;
      this.$emit('search', query)
    },
    input(v) {
      if(!this.onlyValue) {
        this.$emit('input', v)
      } else {
        this.$emit('input', (v && v.value) || null)
      }
      if (this.single) {
        this.$refs.multiselect.toggle();
      }
    },
    addNew(d) {
      this.$emit('addNew', d);
      this.$refs.multiselect.toggle();
    },
    removeFocus() {
      this.$refs.multiselect.blur()
    },
    blur() {
      if (this.m_v) {
        this.is_filter = false;
      }
      this.searchQuery = ''
      this.$emit('blur')
    },
    toggleFilter() {
      this.is_filter = !this.is_filter;
      this.$nextTick(() => {
        this.$refs.multiselect.$el.focus();
      });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.filter-select {
  display: flex;
}

.search-btn {
  border: 1px solid #e8e8e8;
  background: #fff;
  border-radius: 5px;
  width: 46px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

[data-select="Значение не найдено"] {
  span {
    display: none !important;
  }
}

.filter-select {
  width: 100%;

  display: flex;
}

</style>

<style lang="scss">
.filter-select-container {
  .multiselect__tag, .multiselect__option--highlight, .multiselect__option--highlight:after {
    background: #3a8ee6;
  }

  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #3a8ee6 !important;
  }

  .multiselect__tag-icon:after {
    color: #1c5591 !important;
  }

  .el-form-item__content {
    line-height: normal !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FilterSelect.vue